import React from "react";
import Header from "./header";
import Sectiontwo from "./sectiontwo";

function Home(){
    return(
       <><Header /><Sectiontwo/></>
       
    )
}

export default Home;